import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import keycloak from "../../config/keycloak";
import { store } from "../stores/store";
import Loader from "../shared/common/Loader";

export default function RequireAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!keycloak.authenticated,
  );
  const [isVerifying, setIsVerifying] = useState(false);
  const [verificationDone, setVerificationDone] = useState(
    !!store.commonStore.token,
  );

  useEffect(() => {
    const onAuthSuccess = () => setIsAuthenticated(true);
    const onAuthLogout = () => setIsAuthenticated(false);
    const onTokenExpired = () => setIsAuthenticated(false);

    keycloak.onAuthSuccess = onAuthSuccess;
    keycloak.onAuthLogout = onAuthLogout;
    keycloak.onTokenExpired = onTokenExpired;

    return () => {
      keycloak.onAuthSuccess = undefined;
      keycloak.onAuthLogout = undefined;
      keycloak.onTokenExpired = undefined;
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated && !keycloak.token) {
      store.userStore.logout();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated || verificationDone || !keycloak.token) return;

    const verifyUserWithOtp = async () => {
      try {
        setIsVerifying(true);
        await store.userStore.verifyOtp(keycloak.token!);
        setVerificationDone(true);
      } catch (error) {
        console.error("Error verifying OTP:", error);
        setVerificationDone(true);
      } finally {
        setIsVerifying(false);
      }
    };

    verifyUserWithOtp();
  }, [isAuthenticated, verificationDone]);

  if (!isAuthenticated) {
    keycloak.login();
    return null;
  }

  if (isVerifying || !verificationDone) {
    return <Loader />;
  }

  return <Outlet />;
}
